import { useEffect, useState } from "react";
import type { ValidationTemplates } from "features/languages/types/validation-templates";
import { validationTemplatesService } from "features/languages/services/validation-templates-services";

export const useFetchValidationTemplates = (): [ValidationTemplates, boolean] => {
  const [list, setList] = useState<ValidationTemplates>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const abortController = new AbortController();
    setIsLoading(true);

    async function fetchData() {
      try {
        const validationTemplates: ValidationTemplates =
          await validationTemplatesService.getValidationTemplates(abortController);
        setList(validationTemplates || []);
      } catch (error) {
        console.error(error);
      }
      setIsLoading(false);
    }
    fetchData();

    return () => {
      abortController.abort();
    };
  }, []);

  return [list, isLoading];
};
